export default "__VITE_ASSET__EUevT9lx__"